import { NgModule } from "@angular/core";
import { Security2FAEnableModalComponent } from "./components/enable-modal/security-2fa-enable-modal.component";
import { Security2FADisableModalComponent } from "./components/disable-modal/security-2fa-disable-modal.component";
import { Security2FAEnforceModalComponent } from "./components/enforce-modal/security-2fa-enforce-modal.component";
import { TwoFaComponent } from "./components/two-fa/two-fa.component";
import { CoreModule } from "../../../core/core.module";
import { VerificationCommonModule } from "../../../main/components/verification-common/verification-common.module";

const components = [
	Security2FAEnableModalComponent,
	Security2FADisableModalComponent,
	Security2FAEnforceModalComponent,
	TwoFaComponent
];

@NgModule({
	imports: [CoreModule, VerificationCommonModule],
	declarations: [...components],
	exports: [...components]
})
export class Security2faModule {}
